module.exports = __webpack_public_path__ + "static/ClickUp_mini-6ecab35958acd875ce20f862eaed6ac9.svg";